import { Route } from '../types/route';

export const addStepNumbersToRoutes = (routes: string[], mainRoutes: Route[], maxSteps: number) => {
  return routes
    .map((routeLink, index) => {
      const route = mainRoutes.find((route) => route.link === routeLink);
      if (route) {
        return {
          ...route,
          label: index < maxSteps ? `Step ${index + 1}: ${route.label}` : route.label,
        };
      }
      return null;
    })
    .filter(Boolean);
}; 